import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const removeMeFromEvent = async (orgId: string, eventId: string) => {
  const response = await axiosClient.delete(
    `${orgId}/events/${eventId}/participants/me`,
  );
  return response.data;
};

export function useRemoveMeFromEvent(
  orgId: string,
  eventId: string,
  options?: UseMutationOptions<void, HttpError, void>,
) {
  return useMutation({
    mutationFn: () => removeMeFromEvent(orgId, eventId),
    ...options,
  });
}
